/**
 * External dependencies
 */
import { produce } from 'immer';

/**
 * Internal dependencies
 */

import type { ReducerState, ReducerStateDraft } from './types';
import type { SavedColor } from '../../../savedColors/types';

type UpdateSavedColorStateProps = { colorId: string; isLocal: boolean };
type StateProps = Pick<SavedColor, 'error' | 'isLocal' | 'shouldSync'>;

/**
 * Update the local saved colors + any elements that use them.
 * Current page and selection is unchanged.
 */
function updateSavedColorState(
  draft: ReducerStateDraft,
  colorToUpdate: { id: string } & Partial<StateProps>
) {
  const { id, ...colorProps } = colorToUpdate;

  const savedColorIndex = draft.savedColors.findIndex(
    (color) => color.color.id === id
  );

  if (savedColorIndex >= 0) {
    draft.savedColors[savedColorIndex] = {
      ...draft.savedColors[savedColorIndex],
      ...colorProps,
    };
  }
}

// @ts-ignore
export default produce<ReducerState, [UpdateSavedColorStateProps]>(
  updateSavedColorState
);
